module.exports = __webpack_public_path__ + "img/vx1.50bee5f6.png";